import { createTooltip } from "./tooltip-utils"

// Styled hover tooltip for the cap/tax/apron marker lines on a cap bar.
// Native `title` tooltips on these thin ticks were unreliable (no bubble),
// so we render our own positioned tooltip that also escapes the bar's
// overflow-hidden clipping.
export default {
  mounted() {
    this._cleanup = createTooltip(this.el, (el) => `
      <div class="font-bold text-base-content mb-1">
        ${el.dataset.label} <span class="font-mono text-base-content/60">${el.dataset.amount}</span>
      </div>
      <div class="text-base-content/80 leading-relaxed">${el.dataset.tip}</div>
    `, { width: "16rem" })
  },
  destroyed() {
    if (this._cleanup) this._cleanup()
  }
}
